import Loader64 from "@/assets/loader64";
import { useAppSelector } from "@/redux/hooks";

export default function Loader() {
  const uiLoading = useAppSelector((state) => state.ui.loading);

  return uiLoading ? (
    <div className="w-full h-full  flex items-center justify-center fixed z-50 backdrop-blur-xl bg-dark/30 ">
      <div className="flex-col flex items-center justify-center">
        <img src={Loader64} className="cursor-pointer duration-600 w-20" />
        <span className="text-dark text-xl text-shadow-[0_1px_4px_var(--tw-shadow-color)] shadow-gray">
          {uiLoading?.text || "Aguarde um momento"}
        </span>
      </div>
    </div>
  ) : (
    <></>
  );
}
